export default "__VITE_ASSET__LB1cIUnt__"